import layout1 from './layout1/Layout1Config';

const themeLayoutConfigs = {
  layout1,
  // layout2,
  // layout3,
};

export default themeLayoutConfigs;
